import { createSelector } from '@reduxjs/toolkit';
import { selectConfiguration } from 'store/configuration/common/configuration-selectors';

export const selectReportAccess = createSelector(
    selectConfiguration,
    (configuration) => configuration?.reportAccess,
);
